import { EigentumanteilMasterDetailEntryMeta, GbeigentumService, GrundstueckId } from '../../../../core/gb-api';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { AppConfigService } from '../../../../core/services/app-config.service';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { AbstractComponent } from '../../../components/abstract-component/abstract.component';
import { ListLoaderObservable } from '../../../components/list-loader/list-loader-observable';
import { map } from 'rxjs/operators';
import { ListLoader } from '../../../components/list-loader/list-loader';
import { NavTarget } from '../../../components/link/link.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { BeschreibungTableWrapperComponent } from '../../../components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../../directives/history.directive';
import { KompaktGrundstueckComponent } from '../../../kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { KompaktTimepointComponent } from '../../../kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { RechtsgrundComponent } from '../../../kompaktdarstellung/rechtsgrund/rechtsgrund.component';
import { OrderByGrundstuecknummerPipe } from '../../../pipes/order/order-by-grundstuecknummer.pipe';
import { EigentumanteilMasterDetailVM } from '../../../services/eigentumanteil/eigentumanteil-master-detail-vm.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cap-dominierte-grundstuecke',
  templateUrl: './dominierte-grundstuecke.component.html',
  styleUrls: ['./dominierte-grundstuecke.component.scss'],
  imports: [
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    HistoryDirective,
    KompaktGrundstueckComponent,
    KompaktTimepointComponent,
    RechtsgrundComponent,
    TranslatePipe,
    OrderByGrundstuecknummerPipe
  ]
})
export class DominierteGrundstueckeComponent extends AbstractComponent implements OnDestroy, OnChanges {
  _grundstueckId: GrundstueckId;
  listLoader: ListLoader<EigentumanteilMasterDetailVM>;
  historischeDatenSubscription: Subscription;
  protected readonly navigateTo: NavTarget = NavTarget.NAV_GRUNDSTUECK;

  @Input()
  anzeigenAusSichtMeldung = false;

  @Input()
  tableFullWidth: boolean = false;

  @Input()
  hasRight: boolean = true;

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  constructor(
    private eigentumService: GbeigentumService,
    private timepointService: TimepointService,
    private appConfigService: AppConfigService,
    private translateService: TranslateService
  ) {
    super();
  }

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.grundstueckId.currentValue) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
      this.update();
    });
  }

  update() {
    const historischeDaten = this.appConfigService.einstellungHistorischeDaten;
    const timepointCtx = this.timepointService.timepointCtx;

    const observable = this.eigentumService
      .loadEigentumSichtGrundstueck(
        //
        this._grundstueckId.id, //
        false, //
        'BERECHTIGT_SUBJEKTIV_DINGLICH', //
        historischeDaten, //
        timepointCtx.timepointIso, //
        timepointCtx.timepointId //
      )
      .pipe(map((r) => this.crateViewModel(r.entries)));
    this.listLoader = new ListLoaderObservable<EigentumanteilMasterDetailVM>(undefined, 1, observable);
  }

  crateViewModel(entries: EigentumanteilMasterDetailEntryMeta[]): EigentumanteilMasterDetailVM[] {
    const eigentumArray: EigentumanteilMasterDetailVM[] = [];
    for (const entry of entries) {
      eigentumArray.push(new EigentumanteilMasterDetailVM(entry, this.translateService));
    }
    return eigentumArray;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
    this.listLoader.unsubscribeAll();
  }
}
